// extracted by mini-css-extract-plugin
module.exports = {"backLink":"styles-module--backLink--2b44Q"};